module.exports = __webpack_public_path__ + "img/telephone-mobile.94a46c9a.png";